export const regions = [
  "全部地区",
  "中国大陆",
  "美国",
  "韩国",
  "日本",
  "欧洲",
  "影视工厂",
];

export const movieGenres = [
  "全部类型",
  "动作",
  "喜剧",
  "剧情",
  "科幻",
  "悬疑",
  "爱情",
  "奇幻",
  "冒险",
  "犯罪",
  "灾难",
];

export const tvGenres = [
  "全部类型",
  "悬疑",
  "都市",
  "古装",
  "犯罪",
  "医疗",
  "科幻",
  "历史",
  "情感",
  "刑侦",
  "商战",
];

export const years = [
  "全部年份",
  "2026",
  "2025",
  "2024",
  "2023",
  "更早",
];

export const movieSorts = [
  { key: "release", label: "按上映时间" },
  { key: "rating", label: "按评分" },
  { key: "hot", label: "按热度" },
];

export const tvStatusFilters = [
  "全部状态",
  "全季完结",
  "正在热播",
];

export const newsSorts = [
  { key: "time", label: "按时间" },
  { key: "hot", label: "按热门度" },
];

export const newsCategories = [
  "全部",
  "行业观察",
  "技术",
  "平台",
  "评论",
  "推荐",
];